'use strict';

const Enum = require('./enum');
const Devices = require('./devices').Devices;

module.exports.RackspaceContainers = Object.create(Enum, {
  [Devices.BRIDGE]: { value: 'august-venus-firmware', enumerable: true },
  [Devices.DOORBELL]: { value: 'august-mars-firmware', enumerable: true },
  [Devices.DOORBELL_V2]: { value: 'august-rover-firmware', enumerable: true },
  [Devices.DOORBELL_V3]: { value: 'august-hydra-firmware', enumerable: true },
  [Devices.LOCK_V5]: { value: 'august-titan-firmware', enumerable: true },
});
